// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"80":"608a1145","94":"ea20e1f2","314":"ea20e1f2","485":"ea20e1f2","760":"ea20e1f2","962":"adf50c36"}[chunkId] + ".chunk.css";
};